import {
  RxDashboard,
  RxPerson,
  RxExclamationCircled,
  RxCheckCircled,
  RxCounterClockwiseClock,
  RxUpdate,
  RxStar,
  RxFile,
  RxTrash,
} from 'react-icons/rx';

export const adminNavigation = [
  {
    label: 'Overview',
    items: [
      {
        label: 'Dashboard',
        icon: RxDashboard,
        path: '/admin',
      },
    ],
  },
  {
    label: 'User Management',
    items: [
      {
        label: 'All Users',
        icon: RxPerson,
        path: '/admin/users',
      },
      {
        label: 'Pending Requests',
        icon: RxExclamationCircled,
        path: '/admin/pending-requests',
      },
    ],
  },
  {
    label: 'Scenario Management',
    items: [
      {
        label: 'All Scenarios',
        icon: RxFile,
        path: '/admin/scenarios',
      },
      {
        label: 'Pinned Scenarios',
        icon: RxStar,
        path: '/admin/scenarios/pinned',
      },
      {
        label: 'Active Scenarios',
        icon: RxCheckCircled,
        path: '/admin/scenarios/active',
      },
      {
        label: 'Deleted Scenarios',
        icon: RxTrash,
        path: '/admin/scenarios/deleted',
      },
    ],
  },
  {
    label: 'OBPPC Management',
    items: [
      {
        label: 'OBPPC History',
        icon: RxCounterClockwiseClock,
        path: '/admin/obppc-history',
      },
      {
        label: 'Change Requests',
        icon: RxUpdate,
        path: '/admin/change-requests',
      },
    ],
  },
];
